/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentType } from './PaymentType';
import {
    PaymentTypeFromJSON,
    PaymentTypeFromJSONTyped,
    PaymentTypeToJSON,
} from './PaymentType';
import type { PrivateCustomerConsent } from './PrivateCustomerConsent';
import {
    PrivateCustomerConsentFromJSON,
    PrivateCustomerConsentFromJSONTyped,
    PrivateCustomerConsentToJSON,
} from './PrivateCustomerConsent';

/**
 * 
 * @export
 * @interface OrderCartRequest
 */
export interface OrderCartRequest {
    /**
     * 
     * @type {PaymentType}
     * @memberof OrderCartRequest
     */
    paymentType?: PaymentType;
    /**
     * 
     * @type {string}
     * @memberof OrderCartRequest
     */
    referenceSubscriptionId?: string;
    /**
     * 
     * @type {PrivateCustomerConsent}
     * @memberof OrderCartRequest
     */
    privateCustomerConsent?: PrivateCustomerConsent;
}

/**
 * Check if a given object implements the OrderCartRequest interface.
 */
export function instanceOfOrderCartRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OrderCartRequestFromJSON(json: any): OrderCartRequest {
    return OrderCartRequestFromJSONTyped(json, false);
}

export function OrderCartRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderCartRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentType': !exists(json, 'paymentType') ? undefined : PaymentTypeFromJSON(json['paymentType']),
        'referenceSubscriptionId': !exists(json, 'referenceSubscriptionId') ? undefined : json['referenceSubscriptionId'],
        'privateCustomerConsent': !exists(json, 'privateCustomerConsent') ? undefined : PrivateCustomerConsentFromJSON(json['privateCustomerConsent']),
    };
}

export function OrderCartRequestToJSON(value?: OrderCartRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentType': PaymentTypeToJSON(value.paymentType),
        'referenceSubscriptionId': value.referenceSubscriptionId,
        'privateCustomerConsent': PrivateCustomerConsentToJSON(value.privateCustomerConsent),
    };
}

